import { useLocation } from "react-router-dom";
import { useLoginSession } from "../LoginSession";
import Button from "../components/Button";
import "../style/colors.scss";
import "../style/typography.scss";
import "../style/buttons.scss";

import { getPrimaryLandingPage } from "../utils";

/**
 * 404 not found page.
 * @param {object} props
 * @param {string | {superuserHomeRoute: string; userHomeRoute: string; }} [props.homeRoute] The route that the home
 * button will redirect to. This can be an object that specifies a home route for users and admins, or a string
 * if the home route is the same for users and admins.
 * By default the homeroute is derived based on current app, user permissions, and superuser status.
 */
function NotFound({ homeRoute }) {
    const { userInfo } = useLoginSession(false);
    const { pathname } = useLocation();

    const _homeRoute =
        typeof homeRoute === "string"
            ? homeRoute
            : homeRoute
              ? userInfo?.superuser
                  ? homeRoute.superuserHomeRoute
                  : homeRoute.userHomeRoute
              : getPrimaryLandingPage(userInfo);

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "24px" }}>
            <p className="description-1-semibold" style={{ color: "var(--colors-primary-slate-600)" }}>
                Page not found at {pathname}
            </p>

            <Button to={_homeRoute} className="btn-primary btn-sm" style={{ marginTop: "16px", width: "fit-content" }}>
                Go home
            </Button>
        </div>
    );
}

export default NotFound;
